'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_helpers$package$$anon$1(appPageInit$3) {
  this.aXH = null;
  this.aXH = appPageInit$3;
}
export { $c_Lapp_pages_helpers$package$$anon$1 as $c_Lapp_pages_helpers$package$$anon$1 };
$p = $c_Lapp_pages_helpers$package$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_helpers$package$$anon$1;
/** @constructor */
function $h_Lapp_pages_helpers$package$$anon$1() {
}
export { $h_Lapp_pages_helpers$package$$anon$1 as $h_Lapp_pages_helpers$package$$anon$1 };
$h_Lapp_pages_helpers$package$$anon$1.prototype = $p;
$p.oA = (function() {
  return this.aXH.oA();
});
var $d_Lapp_pages_helpers$package$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_helpers$package$$anon$1, "app.pages.helpers$package$$anon$1", ({
  HZ: 1,
  Wg: 1
}));
export { $d_Lapp_pages_helpers$package$$anon$1 as $d_Lapp_pages_helpers$package$$anon$1 };
//# sourceMappingURL=app.pages.helpers$package$$anon$1.js.map
